import { Pipe, PipeTransform } from '@angular/core';
import { KeyValueType } from '@models/common';

@Pipe({
  name: 'assignments',
})
export class AssignmentsPipe implements PipeTransform {
  transform(roleIds: number[], roles: KeyValueType<number>[]): string {
    return roleIds
      .map(id => roles.find(role => role.key === id)?.value)
      .filter(value => value != null)
      .join(', ');
  }
}
